import script from "./VisitasRepository.vue?vue&type=script&lang=js"
export * from "./VisitasRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__